module.exports = __webpack_public_path__ + "static/img/bg2.0630867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/bg2.png
// module id = zzo6
// module chunks = 69